import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import PageHero from '../components/PageHero'
import ScrollReveal from '../components/ScrollReveal'
import CTASection from '../components/CTASection'
import { services } from '../data/siteData'
import { bgPhoto } from '../utils/img'
import './Services.css'

const GALLERY_CATEGORY_BY_SERVICE = {
  'corporate-events': 'Corporate',
  'product-launch': 'Product Launch',
  'private-party': 'Private Party',
  wedding: 'Wedding',
  'stage-decoration': 'Stage Decoration',
  'cultural-award-shows': 'Award',
}

export default function Services() {
  return (
    <>
      <SEO
        title="Our Services | Weddings, Corporate Events & Stage Decoration — AS Elite Gatherings"
        description="Corporate events, product launches, private parties, weddings, stage decoration and award & cultural shows — planned by AS Elite Gatherings in Marthandam, Tamil Nadu."
        keywords="event management services Marthandam, wedding planning Tamil Nadu, corporate event management, stage decoration services, product launch event Marthandam, private party planners, award show production Tamil Nadu"
        path="/services"
      />
      <PageHero
        eyebrow="What We Do"
        title="Six ways we bring a gathering to life"
        text={
          <>
            <Link to="/services#corporate-events">Corporate events</Link>,{' '}
            <Link to="/services#product-launch">product launches</Link>,{' '}
            <Link to="/services#private-party">private parties</Link>,{' '}
            <Link to="/services#wedding">weddings</Link>,{' '}
            <Link to="/services#stage-decoration">stage decoration</Link> and{' '}
            <Link to="/services#cultural-award-shows">award & cultural shows</Link> — each
            planned by the same studio, with the same attention to detail.
          </>
        }
        image="/images/bg/bg5.webp"
      />

      <div className="services-jump container">
        {services.map((s) => (
          <a key={s.id} href={`#${s.id}`} className="services-jump-link">
            {s.name}
          </a>
        ))}
      </div>

      {services.map((service, i) => (
        <section
          id={service.id}
          key={service.id}
          className={`section service-detail ${i % 2 === 1 ? 'section-alt' : ''}`}
        >
          <div className={`container service-detail-inner ${i % 2 === 1 ? 'reverse' : ''}`}>
            <ScrollReveal direction={i % 2 === 1 ? 'right' : 'left'} className="service-detail-media">
              <img src={bgPhoto(service.image, 900, 1000)} alt={service.name} />
              <span className="service-detail-number">{service.number}</span>
            </ScrollReveal>
            <ScrollReveal direction={i % 2 === 1 ? 'left' : 'right'} delay={100} className="service-detail-copy">
              <span className="eyebrow">{service.number} / {String(services.length).padStart(2, '0')}</span>
              <h2 className="gold-underline animate">{service.name}</h2>
              <p>{service.description}</p>
              <ul className="service-highlights">
                {service.highlights.map((h) => (
                  <li key={h}>{h}</li>
                ))}
              </ul>
              <div className="service-detail-actions" style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                <Link to="/booking" className="btn btn-primary">Enquire About This</Link>
                <Link
                  to={`/gallery?category=${encodeURIComponent(GALLERY_CATEGORY_BY_SERVICE[service.id] || 'All')}`}
                  className="btn btn-ghost"
                >
                  See {service.name} Photos
                </Link>
              </div>
            </ScrollReveal>
          </div>
        </section>
      ))}

      <CTASection />
    </>
  )
}
